import QuickStartGuideHero from '@efdigital/ll-xceed-v2/components/coaching/coachee/quick-start-guide-hero';
import QuickStartGuideSections from '@efdigital/ll-xceed-v2/components/coaching/coachee/quick-start-guide-sections';
import QuickStartGuideSupportContacts from '@efdigital/ll-xceed-v2/components/coaching/coachee/quick-start-guide-support-contacts';
import { QUICK_START_GUIDE_SECTIONS } from '@efdigital/ll-xceed-v2/data/coaching/coachee/quick-start-guide';
import { PAGE_WRAPPER } from '@efdigital/ll-xceed-v2/utils/layout';
import { pageTitle } from 'ember-page-title';

<template>
  {{pageTitle "Help and support"}}
  <div class={{PAGE_WRAPPER}}>
    <div class="d-flex flex-column gap-4 gap-lg-5">
      <QuickStartGuideHero />
      <QuickStartGuideSections @sections={{QUICK_START_GUIDE_SECTIONS}} />
      <QuickStartGuideSupportContacts />
    </div>
  </div>
</template>
